<dx-data-grid biz-grid
  exportFileName="Conversions"
  [dataSource]='conversionRows'
  [columns]="currentColumns"
  (onInitNewRow)="initNewRow($event)"
  (onRowInserting)="insertRow($event)"
  (onRowUpdating)="updateRow($event)"
  (onRowRemoving)="removeRow($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onEditingStart)="onEditingStart($event)"
  (onSelectionChanged)='selectionChanged($event)'
  [bizSetAllowColumnReordering]="false"
  [bizSetGroupPanel]="false">
  <dxo-selection showCheckBoxesMode="none"
  mode="multiple"></dxo-selection>
  <dxo-editing mode="batch"
    [allowUpdating]="isEditable"
    [allowAdding]="isEditable"
    [allowDeleting]="isEditable">
  </dxo-editing>
  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
  @if (partnerId) {
    <dxi-column dataField="partner.PartnerName" caption="Partner" dataType="string" allowEditing="false"></dxi-column>
  }
  <dxi-column dataField="IsDefault" caption="Default" dataType="boolean"></dxi-column>
  <dxi-column dataField="row.RowNumber" caption="Row Id" dataType="number" [visible]="false" sortOrder="asc"></dxi-column>

  @for (column of currentConversionTable?.Columns; track column) {
    <dxi-column [dataField]="'conversion_column_id_' + column.ColumnId" [caption]="column.ColumnName" dataType="string" [visible]="true"></dxi-column>
  }

</dx-data-grid>
<hr />
<ng-container *bizPermissionRequired="'Partner_Action_InternalPartner'; evaluator:evaluatePermissions; trigger: selectedPartner">
  @if (currentConversionTable) {
    <div>
      @if (!isEditable) {
        <div class="btn-group">
          @if (editAllowed) {
            <button class="btn btn-primary" (click)="editGrid()">Edit</button>
          }
        </div>
      }
      <div class="btn-group">
        @if (isEditable) {
          <button class="btn btn-primary" (click)="saveGrid()">Save</button>
        }
      </div>
      <div class="btn-group">
        @if (isEditable) {
          <button class="btn btn-link" (click)="cancelGrid()">Cancel</button>
        }
      </div>
      <div class="btn-group">
        <button class="btn btn-link" [hidden]="isEditable" (click)="importData()" *bizPermissionRequired="'Partner_Action_ConversionTableDataImport'">Import Data</button>
      </div>
      <div class="btn-group">
        @if (editAllowed && isDeletable) {
          <button class="btn btn-primary" (click)="deleteData()">Delete Selected Rows</button>
        }
      </div>
      @if (partnerId) {
        <div class="btn-group">
          <div class="control control-checkbox">
            <label *bizPermissionRequired="'Partner_Action_ConversionTableDataShowFromOtherPartners'">Show values from other partners<input [disabled]="isEditable" type="checkbox" [ngModel]="showAllPartners" (ngModelChange)="showPartners($event)" /><i></i> </label>
          </div>
        </div>
      }
    </div>
  }
</ng-container>
